window.EventBus.addEventListener('updated-cart', (event) => {
  const quantity = document.querySelector('#cart-quantity');
  if (null !== quantity) {
    quantity.innerHTML = event.detail.quantity;
    if (0 === event.detail.quantity) {
      quantity.classList.add('d-none');
    } else {
      quantity.classList.remove('d-none');
    }
  }
});
